import { createSelector } from '@reduxjs/toolkit';
import { externalConnectionsNotDeleted } from './external-connections-not-deleted';
import { networksForMap } from './networks-for-map';
import { employeeNamesById } from '../employees/employee-names-by-id';
import { partnerNamesById } from '../partners/partner-names-by-id';
import type { ExternalConnectionViewModel } from '@trinnvis/dabih-api-client';
import { alertsForExternalConnections } from './alerts-for-external-connections';
import { calculateConnectedViaNhn } from './calculate-connected-via-nhn';
import { firstBy } from 'thenby';

export const externalConnectionsForMap = createSelector(
  externalConnectionsNotDeleted,
  networksForMap,
  employeeNamesById,
  partnerNamesById,
  (externalConnections, networks, employeeNamesById, partnerNamesById) => {
    const map: (ExternalConnectionViewModel & { alerts: string[]; connectedViaNhn: boolean })[] =
      externalConnections.map((c) =>
        Object.assign({}, c, {
          alerts: alertsForExternalConnections(c, networks),
          name: nameForExternalConnection(c),
          connectedViaNhn: calculateConnectedViaNhn(c, networks),
        }),
      );

    map.sort(
      firstBy<ExternalConnectionViewModel>('type', -1)
        .thenBy((v: { employeeUuid?: string; partnerUuid?: string }) => nameForExternalConnection(v).toLowerCase())
        .thenBy('uuid'),
    );

    function nameForExternalConnection(v: { employeeUuid?: string; partnerUuid?: string }) {
      if (v.employeeUuid) {
        return employeeNamesById[v.employeeUuid];
      } else if (v.partnerUuid) {
        if (partnerNamesById[v.partnerUuid]) {
          return partnerNamesById[v.partnerUuid];
        } else {
          return '';
        }
      } else {
        return '';
      }
    }

    return map;
  },
);
